import { render, staticRenderFns } from "./ToastNotificationArea.vue?vue&type=template&id=773279d7&scoped=true&"
import script from "./ToastNotificationArea.vue?vue&type=script&lang=ts&"
export * from "./ToastNotificationArea.vue?vue&type=script&lang=ts&"
import style0 from "./ToastNotificationArea.vue?vue&type=style&index=0&id=773279d7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773279d7",
  null
  
)

export default component.exports